
let clickSource = null;

function removeFilterScroll(e){
  const filterInsideShapeSection = e.target.closest(".openFilterBtn");
  const removeFilter = e.target.closest(".kirb-new-filter-section-mobile");
  const filtercloseBtnview = e.target.closest(".filtercloseBtnview");
    
  if (filterInsideShapeSection) {
    document.body.style.overflow = "hidden";
  } else if (e.target === removeFilter || e.target === filtercloseBtnview) {
    document.body.style.overflow = "";
    return;
  }
}

document.addEventListener("click", function (e) {
   
  if (!e.isTrusted && clickSource == null) {
    return;  // ignore programmatic .click()
  }

  removeFilterScroll(e);

  if (e.target.classList.contains("cross-line") || e.target.classList.contains("light-text") || e.target.querySelector(".light-text")) {

    document
    .querySelectorAll(".kirb-shape-section-js .kirb-ring-item .kirb-ring-item-img")
    .forEach(el => {
      if (!el.classList.contains("active")) {
        el.closest(".kirb-ring-item")?.classList.remove("active");
      }
    });

    document
    .querySelectorAll(".kirb-stone-section-js .kirb-ring-item .kirb-ring-item-img")
    .forEach(el => {
      if (!el.classList.contains("active")) {
        el.closest(".kirb-ring-item")?.classList.remove("active");
      }
    });

    document
    .querySelectorAll(".kirb-ring-section-js .kirb-ring-item .kirb-ring-item-img, .kirb-ring-section-desktop-js .kirb-ring-item .kirb-ring-item-img")
    .forEach(el => {
      if (!el.classList.contains("active")) {
        el.closest(".kirb-ring-item")?.classList.remove("active");
      }
    });

    document
    .querySelectorAll(".kirb-metal-item .kirb-metal-item-img")
    .forEach(el => {
      if (!el.classList.contains("active")) {
        el.closest(".kirb-metal-item").classList.remove("active");
      }
    });

  }

  // fine style section
  const finestyle_item = e.target.closest(".kirb-fine-styles-section-js .kirb-ring-item, .collection-fine-jewellery .kirb-ring-item");
  if (finestyle_item){

    if(finestyle_item.classList.contains("active")){
      finestyle_item.classList.remove("active");
      finestyle_item.querySelector(".kirb-ring-item-img").classList.remove("active");
      finestyle_item.querySelector("span").classList.remove("active");
      return;
    }
      //Remove `active` from all metal items
    document.querySelectorAll(".kirb-fine-styles-section-js .kirb-ring-item, .collection-fine-jewellery .kirb-ring-item").forEach(el => {
      if (el.classList.contains("active")) {
        el.click();
        el.classList.remove("active");
        el.querySelector(".kirb-ring-item-img").classList.remove("active");
        el.querySelector("span").classList.remove("active");
      }
    });

    // Activate clicked item
    finestyle_item.classList.add("active");
    finestyle_item.querySelector(".kirb-ring-item-img").classList.add("active");
    finestyle_item.querySelector("span").classList.add("active");
    return;

  }

  // fine gemstone section
  const finegemstone_item = e.target.closest(".kirb-fine-gemstones-section-js .kirb-ring-item");
  if (finegemstone_item){

    if(finegemstone_item.classList.contains("active")){
      finegemstone_item.classList.remove("active");
      finegemstone_item.querySelector(".kirb-ring-item-img").classList.remove("active");
      finegemstone_item.querySelector("span").classList.remove("active");
      return;
    }
      //Remove `active` from all metal items
    document.querySelectorAll(".kirb-fine-gemstones-section-js .kirb-ring-item").forEach(el => {
      if (el.classList.contains("active")) {
        el.click();
        el.classList.remove("active");
        el.querySelector(".kirb-ring-item-img").classList.remove("active");
        el.querySelector("span").classList.remove("active");
      }
    });

    // Activate clicked item
    finegemstone_item.classList.add("active");
    finegemstone_item.querySelector(".kirb-ring-item-img").classList.add("active");
    finegemstone_item.querySelector("span").classList.add("active");
    return;

  }

  // shape section
  const shape_item = e.target.closest(".kirb-shape-section-js .kirb-ring-item");
  if (shape_item){

   if (shape_item.classList.contains("active")) {
      shape_item.classList.remove("active");
      shape_item.querySelector(".kirb-ring-item-img").classList.remove("active");
      shape_item.querySelector("span").classList.remove("active");
      return;
    }
      //Remove `active` from all metal items
    document.querySelectorAll(".kirb-shape-section-js .kirb-ring-item").forEach(el => {
    if (el != shape_item && (el.classList.contains("active") || el.querySelector(".kirb-ring-item-img")?.classList.contains("active"))) {
        el.click();
        el.classList.remove("active");
        el.querySelector(".kirb-ring-item-img").classList.remove("active");
        el.querySelector("span").classList.remove("active");
    }
    });

    // Add `active` to the clicked one
    shape_item.classList.add("active");
    shape_item.querySelector(".kirb-ring-item-img").classList.add("active");
    shape_item.querySelector("span").classList.add("active");
    return;

  }

  // side stone section
  const side_item = e.target.closest(".kirb-stone-section-js .kirb-ring-item");
  if (side_item){

            if(side_item.classList.contains("active")){
                           side_item.classList.remove("active");
                          side_item.querySelector(".kirb-ring-item-img").classList.remove("active");
                        side_item.querySelector("span").classList.remove("active");
            return;
            }
    // Remove `active` from all ring items
    document.querySelectorAll(".kirb-stone-section-js .kirb-ring-item").forEach(el => {
      if (el.classList.contains("active")) {
        el.click();
        el.classList.remove("active");
        el.querySelector(".kirb-ring-item-img").classList.remove("active");
        el.querySelector("span").classList.remove("active");
      }
    });

    // Add `active` to the clicked one
    side_item.classList.add("active");
    side_item.querySelector(".kirb-ring-item-img").classList.add("active");
    side_item.querySelector("span").classList.add("active"); 
    return;

  }

  // ring section
  const item = e.target.closest(".kirb-ring-item");
  if (item){

            if(item.classList.contains("active")){
                           item.classList.remove("active");
                          item.querySelector(".kirb-ring-item-img").classList.remove("active");
                        item.querySelector("span").classList.remove("active");
            return;
            }
      // Remove `active` from all ring items
    document.querySelectorAll(".kirb-ring-section-js .kirb-ring-item, .kirb-ring-section-desktop-js .kirb-ring-item").forEach(el => {
      if (el.classList.contains("active")) {
        el.click();
        el.classList.remove("active");
        el.querySelector(".kirb-ring-item-img").classList.remove("active");
        el.querySelector("span").classList.remove("active");
      }
    });

    // Add `active` to the clicked one
    item.classList.add("active");
    item.querySelector(".kirb-ring-item-img").classList.add("active");
    item.querySelector("span").classList.add("active"); 
    return;
  }

  // metal section
  const metal_item = e.target.closest(".kirb-metal-item");
  if (metal_item){

    if(metal_item.classList.contains("active")){
      metal_item.classList.remove("active");
      metal_item.querySelector(".kirb-metal-item-img").classList.remove("active");
      metal_item.querySelector("span").classList.remove("active");
      return;
    }
      //Remove `active` from all metal items
    document.querySelectorAll(".kirb-metal-item").forEach(el => {
      if (el.classList.contains("active")) {
        el.click();
        el.classList.remove("active");
        el.querySelector(".kirb-metal-item-img").classList.remove("active");
        el.querySelector("span").classList.remove("active");
      }
    });

    // Activate clicked item
    metal_item.classList.add("active");
    metal_item.querySelector(".kirb-metal-item-img").classList.add("active");
    metal_item.querySelector("span").classList.add("active");
    return;

  }

});

document.addEventListener("DOMContentLoaded", () => {
    activeSync();
    radioFilter();

const el = document.querySelector('.collection-fine-jewellery');

if (el && window.getComputedStyle(el).display != 'none') {
  el.classList.add('not-hidden');
}

});

function activeSync(){
  const filter = document.querySelector('.kirb-ring-item-img.active');
  if (filter) {
    const parent = filter.closest('.kirb-ring-item'); // change selector if needed
    if (parent) parent.classList.add('active');
  }

  const metal_filter = document.querySelector('.kirb-metal-item-img.active');
  if (metal_filter) {
    const parent = metal_filter.closest('.kirb-metal-item'); // change selector if needed
    if (parent) parent.classList.add('active');
  }
}

function radioFilter(){

      // Select the main static container for all filters
    const staticContainer = document.querySelector('.facets__accordion'); 
    
    // If the static container doesn't exist, use the document body as a fallback
    const targetElement = staticContainer || document.body;

    // Attach a single click listener to the static parent
    targetElement.addEventListener('change', function(event) {
        // 1. Check if the element that triggered the 'change' event is a checkbox inside a filter
        if (event.target.matches('input[type="checkbox"]')) {
            const clickedCheckbox = event.target;
            
            // 2. Identify the parent filter group container (e.g., Gemstone, Style)
            // We use .closest() to find the nearest parent <div> with the class 'accordion__body facets__accordion-body'
            const filterGroupContainer = clickedCheckbox.closest('.accordion__body.facets__accordion-body');
            
            // Check if we successfully found a filter group (and skip the price filter logic)
            if (filterGroupContainer && filterGroupContainer.id !== 'Filters-accordion-dropdown-4') {
                
                // 3. Ensure the clicked checkbox is checked before deselecting others
                if (clickedCheckbox.checked) {
                    
                    // 4. Get all checkboxes *within* this specific filter group
                    const checkboxesInGroup = filterGroupContainer.querySelectorAll('input[type="checkbox"]');
                    
                    // 5. Deselect all other checkboxes in the group
                    checkboxesInGroup.forEach(otherCheckbox => {
                        if (otherCheckbox !== clickedCheckbox) {
                            otherCheckbox.checked = false;
                        }
                    });

                    // 6. ❗ Trigger the filter update after the change
                    // This is still critical for the filter results to refresh.
                    // This example assumes your filter lives inside a <form> element.
                    // clickedCheckbox.closest('form').dispatchEvent(new Event('change'));
                }
            }
        }
    });

}

// FIlter New UI
document.addEventListener("DOMContentLoaded", function () {

  const params = new URLSearchParams(window.location.search);

  const metalParams = params.getAll("filter.v.option.metal type");

  if (metalParams.length) {
    const normalizedMetals = metalParams.map(metal =>
      metal
        .replace(/(\d+K)\s*/gi, "") // remove 14K, 10K, etc.
        .replace(/\s+/g, "")        // remove spaces
        .toLowerCase()              // lowercase
    );

    const uniqueMetals = [...new Set(normalizedMetals)];

    uniqueMetals.forEach(metal => {
      activateFilter(metal); 
    });
  }

});

function activateFilter(name) {

  const filterItem = document.querySelector(`.custom-filter[data-name="${name}"]`);

  if (!filterItem) return;

  // Add active class
  filterItem.classList.add("active");

  const img = filterItem.querySelector(".kirb-ring-item-img");
  if (img) {
    img.classList.add("active");
  }
}

document.addEventListener("click", function (e) {


  if (!e.isTrusted && clickSource == null ) {
    return;  // ignore programmatic .click()
  }

  clickSource = null;

  const item = e.target.closest(".custom-filter");
  if (item) {
    let name = item.dataset.name;

    // trigger metal clicks
    if (name === "rose-gold" || name === "white-gold" || name === "yellow-gold" || name === "platinum") {
      const metal_item = document.querySelector('.kirb-new-filter-section-mobile .kirb-metal-item.item-' + name);
      metal_item.click();
      if (metal_item){
             if(metal_item.classList.contains("active")){
                metal_item.classList.remove("active");
                metal_item.querySelector(".kirb-metal-item-img").classList.remove("active");
                metal_item.querySelector("span").classList.remove("active");
                return;
            }
        //Remove `active` from all metal items
        document.querySelectorAll(".kirb-metal-item").forEach(el => {
          if (el.classList.contains("active")) {
            el.click();
            el.classList.remove("active");
            el.querySelector(".kirb-metal-item-img").classList.remove("active");
            el.querySelector("span").classList.remove("active");
          }
        });

        // Activate clicked item
        metal_item.classList.add("active");
        metal_item.querySelector(".kirb-metal-item-img").classList.add("active");
        metal_item.querySelector("span").classList.add("active");
      }
    }
  }

});

function sync_button(){

  const metals = document.querySelectorAll(".kirb-metal-item-img");
  metals.forEach(metal => {
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        // Get metal name class (e.g. "white-gold")
        const metalName = [...metal.classList].find(cls =>
          cls !== "kirb-metal-item-img" && cls !== "active"
        );

        // Find matching ring item
        const ringItem = document.querySelector(
          `.kirb-ring-item-img .eng-${metalName.replace('-','')}`
        )?.parentElement;

        if (!ringItem) return;

        // Sync active state
        if (metal.classList.contains("active")) {
          ringItem.classList.add("active");
        } else {
          ringItem.classList.remove("active");
        }
      }
    });
  });

  observer.observe(metal, {
    attributes: true,
    attributeFilter: ["class"]
  });
  });

document.querySelectorAll('.kirb-new-filter-section-mobile .kirb-metal-section.kirb-filter-show-section .kirb-metal-item').forEach(el => {
  const img = el.querySelector('.kirb-metal-item-img');

  if (img && img.classList.contains('active')) {
    let name = el.dataset.name;

    if(name=="white-gold"){
      name = "whitegold"
    }else if(name=="rose-gold"){
      name = "rosegold"
    }else if(name=="yellow-gold"){
      name = "yellowgold"
    }else if(name=="platinum"){
      name = "platinum"
    }

    const target = document.querySelector(`.kirb-ring-item-img:has(.eng-${name})`);
    console.log("target+++++",target)
    if (target) {
      target.classList.add("active");
    }
  }
});
  
}

function app_custom() {
  let addHTMLString = '';
  const Heading = document.querySelector(".filters-containers .kirb-new-filter-section-laptop .heading-fiter");


  if (Heading) {
          Heading.innerHTML = "<h2>FILTERS</h2>";

     addHTMLString = `
    <div data-name="white-gold" class="item-white-gold custom-filter" style="order:102">
    <div class="kirb-ring-item-img">
      <div class="shape-eng-sprite eng-whitegold"></div>
    </div>
    <span>White Gold</span>
  </div>
    <div data-name="yellow-gold" class="item-yellow-gold custom-filter" style="order:101">
    <div class="kirb-ring-item-img">
      <div class="shape-eng-sprite eng-yellowgold"></div>
    </div>
    <span>Yellow Gold</span>
  </div>
  <div data-name="rose-gold" class="item-rose-gold custom-filter" style="order:104">
    <div class="kirb-ring-item-img">
      <div class="shape-eng-sprite eng-rosegold"></div>
    </div>
    <span>Rose Gold</span>
  </div> 
    <div data-name="platinum" class="item-platinum custom-filter" style="order:116">
    <div class="kirb-ring-item-img">
      <div class="shape-eng-sprite eng-platinum"></div>
    </div>
    <span>Platinum</span>
  </div>`;
  }


 let slider = document.querySelector('.collection-ring');

 if(!slider)
    return;

  const Jewellery_filter = document.querySelector(".collection-fine-jewellery");
  if(Jewellery_filter){
    const isHidden = window.getComputedStyle(Jewellery_filter).display === "none";
    if(!isHidden){
      slider = document.querySelector('.collection-fine-jewellery');
    }else{
      slider = document.querySelector('.collection-ring');
    }
  }

  slider.insertAdjacentHTML('beforeend', addHTMLString);

 sliderFun(slider);
 sync_button();
 setTimeout(() => {
   selected_filter();
 }, 0);

}

function selected_filter() {
  const collection_metafield = document.getElementById('collection_metafield');
  if (!collection_metafield) return;

  const { style, shape, metal , gemstone } = collection_metafield.dataset;

  const clickByDataName = (value) => {
    if (!value) return;

    const el = document.querySelector(`[data-name="${value}"]`);
    if (!el) return;

    const ringItem = el.querySelector('.kirb-ring-item-img');

    // click only if not already active
    if (ringItem && !ringItem.classList.contains('active')) {
      clickSource = 'collections';
      el.click();
      clickSource = null;
    }
  };

  clickByDataName(style);
  clickByDataName(shape);
  clickByDataName(metal);
  clickByDataName(gemstone);
}

function sliderFun(slider){
  // 1. Get Arrow Elements
  const leftArrow = document.querySelector('.ring-left-arrow');
  const rightArrow = document.querySelector('.ring-right-arrow');

 // 2. Initial Setup (Drag-to-Scroll Logic)
  let isDown = false;
  let startX;
  let scrollLeft;

 if (slider) {
    // Initial check when the page loads
    updateRingSliderArrows(slider, leftArrow, rightArrow);

    // Event listener for scroll changes (drag, arrow clicks, etc.)
    slider.addEventListener('scroll', () => {
        updateRingSliderArrows(slider, leftArrow, rightArrow);
    });
    
    // Also check on window resize, as maxScroll changes
    window.addEventListener('resize', () => {
        updateRingSliderArrows(slider, leftArrow, rightArrow);
    });

    // --- Mouse Drag Logic (Your Original Code) ---
    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return; // stop when not dragging
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3; // scroll speed multiplier
        slider.scrollLeft = scrollLeft - walk;
    });


            if (leftArrow) {
            leftArrow.addEventListener('click', () => {
                // *** CORRECTION: Use scrollTo with left: 0 ***
                // scrollTo sets the absolute scroll position.
                slider.scrollTo({
                    left: 0,
                    behavior: 'smooth'
                });
            });
        }

        if (rightArrow) {
            rightArrow.addEventListener('click', () => {
                const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
                
                // *** CORRECTION: Use scrollTo to set the exact end position ***
                // scrollBy would overscroll if not starting from the beginning.
                slider.scrollTo({
                    left: maxScrollLeft,
                    behavior: 'smooth'
                });
            });
        }
 }
  
}

function updateRingSliderArrows(slider, leftArrow, rightArrow) {
    if (!slider || !leftArrow || !rightArrow) return;

    const scrollPosition = slider.scrollLeft;
    const maxScroll = slider.scrollWidth - slider.clientWidth;
    const tolerance = 5;

    // LEFT ARROW
    if (scrollPosition <= tolerance) {
        leftArrow.classList.add("arrow-hidden");
        leftArrow.classList.remove("arrow-visible");
    } else {
        leftArrow.classList.remove("arrow-hidden");
        leftArrow.classList.add("arrow-visible");
    }

    // RIGHT ARROW
    if (scrollPosition >= maxScroll - tolerance) {
        rightArrow.classList.add("arrow-hidden");
        rightArrow.classList.remove("arrow-visible");
    } else {
        rightArrow.classList.remove("arrow-hidden");
        rightArrow.classList.add("arrow-visible");
    }
}

// Run initially
app_custom();

// Select the parent container
const appMainBlock = document.querySelector(".app-main-block .filters-containers");
let headingsUpdated = false;

if (appMainBlock) {
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.addedNodes.length && !headingsUpdated) {
        headingsUpdated = true; // only run once
        app_custom(); // run your function whenever new nodes are added inside app-main-block
      }
    });
  });

  // Observe only the app-main-block subtree
  observer.observe(appMainBlock, { childList: true, subtree: true });
}
